import type { Layer, Space } from '~/packages/general/variable/spaceTime.types'

export const hasGeographyChanged = (previousSpace: Space, nextSpace: Space) => {
  if (previousSpace.delimitationType !== nextSpace.delimitationType) {
    return true
  }

  const previousDelimitationId =
    'delimitationId' in previousSpace ? (previousSpace.delimitationId ?? null) : null
  const nextDelimitationId =
    'delimitationId' in nextSpace ? (nextSpace.delimitationId ?? null) : null

  if (previousDelimitationId !== nextDelimitationId) {
    return true
  }

  const previousIsCustom = previousSpace.delimitationType === 'custom'
  const nextIsCustom = nextSpace.delimitationType === 'custom'
  if (previousIsCustom || nextIsCustom) {
    if (previousIsCustom !== nextIsCustom) {
      return true
    }

    const previousCustom =
      'delimitationCustom' in previousSpace ? previousSpace.delimitationCustom : null
    const nextCustom = 'delimitationCustom' in nextSpace ? nextSpace.delimitationCustom : null
    return previousCustom !== nextCustom
  }

  if (previousSpace.childrenType !== nextSpace.childrenType) {
    if (previousSpace.childrenType === 'item' && nextSpace.childrenType === 'item') {
      return false
    }
    return true
  }

  return false
}

export function normalizeLayerTimeAfterGeographyChange(
  previousLayer: Layer,
  nextLayer: Layer,
  getDefaultTimeForVariable?: (variable: Layer['variable']) => Layer['time'],
): Layer {
  const didGeographyChange = hasGeographyChanged(previousLayer.space, nextLayer.space)

  // Preserva o tempo escolhido ao mudar a geografia (Onde).
  // Só força o default quando um intervalo de datas (incidence) está incompleto.
  if (didGeographyChange && nextLayer.variable.timeType === 'incidence') {
    const time = nextLayer.time
    const hasCompleteRange =
      'startDate' in time && 'endDate' in time && Boolean(time.startDate && time.endDate)
    if (!hasCompleteRange && getDefaultTimeForVariable) {
      return {
        ...nextLayer,
        time: getDefaultTimeForVariable(nextLayer.variable),
      }
    }
  }

  return nextLayer
}

export function normalizeLayersTimeAfterGeographyChange(
  previousLayers: Layer[],
  nextLayers: Layer[],
  getDefaultTimeForVariable?: (variable: Layer['variable']) => Layer['time'],
): Layer[] {
  return nextLayers.map((layer, index) => {
    const previousLayer = previousLayers[index]
    if (!previousLayer) {
      return layer
    }

    return normalizeLayerTimeAfterGeographyChange(previousLayer, layer, getDefaultTimeForVariable)
  })
}
